import React from 'react';
import { Card, CardContent, CardHeader, Input, InputLabel } from '@mui/material';
import { CardTitle } from 'components/CardTitle';
import { AdvancedKrarkConfigurationKey, ResourceGeneration } from 'types';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store';
import { updateAdvancedConfig } from '../../../store/configSlice';

interface PerXProps {
  category: AdvancedKrarkConfigurationKey;
  krarkPerXConfig: ResourceGeneration;
  className?: string;
}

export const PerX: React.FC<PerXProps> = ({ category, krarkPerXConfig }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  return (
    <Card
      key={category}
      className="shadow-md border-2 border-gray-200 hover:shadow-lg transition-shadow duration-200"
    >
      <CardHeader
        className="bg-gradient-to-r from-indigo-50 to-purple-50"
        title={
          <CardTitle className="text-lg font-bold text-gray-900">{t('key.' + category)}</CardTitle>
        }
      />
      <CardContent className="p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <InputLabel className="text-sm font-medium text-gray-700">Cards Drawn</InputLabel>
            <Input
              type="number"
              inputProps={{ min: 0 }}
              value={krarkPerXConfig.cardsDrawn}
              onChange={(e) =>
                dispatch(
                  updateAdvancedConfig({
                    path: category + '.cardsDrawn',
                    value: Number(e.target.value),
                  }),
                )
              }
              className="h-12 text-lg border-2 transition-all duration-200 hover:shadow-md"
            />
          </div>

          <div className="space-y-2">
            <InputLabel className="text-sm font-medium text-gray-700">Treasures Created</InputLabel>
            <Input
              type="number"
              inputProps={{ min: 0 }}
              value={krarkPerXConfig.treasuresCreated}
              onChange={(e) =>
                dispatch(
                  updateAdvancedConfig({
                    path: category + '.treasuresCreated',
                    value: Number(e.target.value),
                  }),
                )
              }
              className="h-12 text-lg border-2 transition-all duration-200 hover:shadow-md"
            />
          </div>
        </div>

        {/* <ManaInput
                  mana={rewards[category].mana}
                  onChange={(mana) => updateMana(category, mana)}
                  label="Mana Generated"
                /> */}
      </CardContent>
    </Card>
  );
};
